import { create } from 'zustand';

interface SystemDocumentsState {
  // set when the backend rejects a request with SYSTEM_DOCUMENT_ACCEPTANCE_REQUIRED
  acceptanceRequiredByApi: boolean;
  isLegalDocumentsDrawerOpen: boolean;
  setAcceptanceRequiredByApi: (required: boolean) => void;
  openLegalDocumentsDrawer: () => void;
  closeLegalDocumentsDrawer: () => void;
}

export const useSystemDocumentsStore = create<SystemDocumentsState>((set) => ({
  acceptanceRequiredByApi: false,
  isLegalDocumentsDrawerOpen: false,
  setAcceptanceRequiredByApi: (required) =>
    set({ acceptanceRequiredByApi: required }),
  openLegalDocumentsDrawer: () => set({ isLegalDocumentsDrawerOpen: true }),
  closeLegalDocumentsDrawer: () => set({ isLegalDocumentsDrawerOpen: false }),
}));
